import * as React from 'react'
import { BREAKPOINT_TABLET_LARGE, COLORS } from 'static/constants'
import styled from 'styled-components'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  title: string
  value: string
  transition?: string
  type?: 'up' | 'down' | 'flat'
}

const SummaryItem: React.VFC<IProps> = ({ title, value, transition, type }) => {
  const icon = React.useMemo(() => {
    if (type === 'up') {
      return (
        <SvgIcon name="arrow_circle_up" className="icon" ariaHidden={true} role="presentation" />
      )
    }
    if (type === 'down') {
      return (
        <SvgIcon name="arrow_circle_down" className="icon" ariaHidden={true} role="presentation" />
      )
    }
    if (type === 'flat') {
      return (
        <SvgIcon name="arrow_circle_right" className="icon" ariaHidden={true} role="presentation" />
      )
    }
  }, [type])
  const calc = React.useMemo(() => {
    if (type === 'up') {
      return '+'
    }
    return ''
  }, [type])
  return (
    <Item>
      <p className="title">{title}</p>
      <p className="value">{value}</p>
      <p className={`transition ${type}`}>
        {icon}
        {calc}
        {transition}
      </p>
    </Item>
  )
}

const Item = styled.div`
  width: 25%;
  text-align: center;
  font-weight: 700;
  @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
    width: 50%;
  }
  .title {
    font-size: 12px;
    color: ${COLORS.subText};
  }
  .value {
    font-size: 28px;
  }
  .transition {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    .icon {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
    &.up {
      color: ${COLORS.successText};
    }
    &.down {
      color: ${COLORS.cautionText};
    }
    &.flat {
      color: ${COLORS.useallyText};
    }
  }
`
export default SummaryItem
